var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tab_list"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,staticClass:"tab_item",class:index == _vm.currentTab ? 'tab_item_active' : '',on:{"click":function($event){return _vm.clickTabs(index)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }